module.exports = __webpack_public_path__ + "static/media/part2.16c5c23f.png";